import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/despre-noi/")({
  head: () => routeHead("/despre-noi/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <About />
  );
}
